// This function runs when the user clicks to download the orders.  It takes in
// selectedDate and the string of orders as arguments that can be read by a docx
// file.
export default function DownloadOrders(
  downloadString,
  distributionDate,
  distributionLocation,
  fileNameSpecial,
  includePageNumbers,
) {
  // Base stylesheet used by every export.
  let style =
    ".order-container {border: 1px solid #000;padding: 10px;margin-bottom: 20px;width: calc(50% - 10px);box-sizing: border-box;}.order-container p, .order-container ul {margin: 0;padding: 0;}";

  // Wrapping section + footer used when the caller wants Word to render page
  // numbers.  Word only renders page numbers inside a <div class='Section1'>
  // whose @page rule references a footer via mso-footer, and the footer itself
  // uses the PAGE field code.  Leaving this opt-in keeps every other export
  // unchanged.  Note: Word also renders the footer div inline at the end of
  // the body (showing a "Page of" line without resolved field codes).  We've
  // accepted that trade-off since hiding the inline copy also hides the real
  // footer.
  let bodyOpen = "<body>";
  let bodyClose = "</body>";
  if (includePageNumbers) {
    style +=
      "@page Section1 {size: 8.5in 11.0in; margin: 1in 1in 1in 1in; mso-footer: f1; mso-page-numbers: 1;} div.Section1 {page: Section1;} p.footer {margin: 0; text-align: center; font-size: 12px;}";
    bodyOpen = `<body><div class='Section1'>`;
    bodyClose = `</div><div style='mso-element:footer' id='f1'><p class='footer'>Page <span style='mso-field-code: PAGE '></span> of <span style='mso-field-code: NUMPAGES '></span></p></div></body>`;
  }

  const preHtml = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title><style>${style}</style></head>${bodyOpen}`;
  const postHtml = bodyClose + "</html>";

  const html = preHtml + downloadString + postHtml;

  // Specify link url
  const url =
    "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

  // Specify file name
  let filename = `${distributionLocation}-CommunityOrders-${distributionDate}.doc`;
  // If there is a special string sent it to name the file then update it.
  if (fileNameSpecial != null) {
    filename = `${distributionLocation}-${fileNameSpecial}.doc`;
  }

  // Create download link downloadString
  const downloadLink = document.createElement("a");

  document.body.appendChild(downloadLink);

  // Create a link to the file
  downloadLink.href = url;

  // Setting the file name
  downloadLink.download = filename;

  // triggering the function
  downloadLink.click();

  document.body.removeChild(downloadLink);
}
